import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_SUBSCRIPTION } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Payment',
        key: 'Subscription',
        name: 'Subscription',
        icon: 'fas fa-shopping-cart'
    },
    {
        parent: 'Payment.Subscription',
        key: 'Item',
        name: 'Item',
        icon: 'fas fa-clipboard-list',
        route: { name: ROUTE_NAME_SUBSCRIPTION.INDEX }
    }
]);

export default registerRouteForModule(router);
